import { ChangeDetectorRef, Component } from '@angular/core';
import { formatCurrency } from '@angular/common';

import {CollateralObjectsService} from './collateral-objects.service';
import {CollateralObjects, CollateralObjectsResponse} from './collateral-objects.model';
import {COLLATERAL_OBJECTS_API, COLLATERAL_OBJECTS_ERROR_NO_ITEMS} from './collateral-objects.constants';

@Component({
  selector: 'app-collateral-objects',
  templateUrl: './collateral-objects.component.html',
  styleUrls: ['./collateral-objects.component.css'],
})

export class CollateralObjectsComponent {
  tableData: CollateralObjects[];
  initialized = false;
  errorText: string;
  emptyValuePlaceholder = '--';
  tableColumns: string[];
  panelOpenState = true;
  showTable = false;
  busyCursorText = 'busy-cursor';

  constructor(private changeRef: ChangeDetectorRef, private collateralObjectsService: CollateralObjectsService) {
    this.tableColumns = ['address', 'executionValueAmount', 'liquidationValueAmount', 'taxationDate'];
  }

  loadCollateralObjects() {
    if (this.initialized) {
      document.body.classList.remove(this.busyCursorText);
      return;
    }
    document.body.classList.add(this.busyCursorText);
    this.collateralObjectsService.getTableData(COLLATERAL_OBJECTS_API)
      .subscribe((resp: CollateralObjectsResponse) => {
        this.tableData = ('collateralObjects' in resp) ? resp.collateralObjects : [];
        this.showTable = this.tableData.length ? true : false;
        this.errorText = resp.listOfError.length ? COLLATERAL_OBJECTS_ERROR_NO_ITEMS : '';
        this.initialized = true;
        document.body.classList.remove(this.busyCursorText);
      }, (error) => {
        document.body.classList.remove(this.busyCursorText);
      });

  }

  formatAmount(value, currency: string) {
    if (value || value === 0) {
      value = formatCurrency(value, 'nl', '€', currency);
    } else {
      value = this.emptyValuePlaceholder;
    }
    return value;
  }
}
